import styled, { css } from 'styled-components';
import _Section from 'src/features/PussInBoots/PussInBootsTopicOfTopicPageContent/Section';
import BackgroundDesktop from 'src/features/PussInBoots/PussInBootsTopicOfTopicPageContent/LearnImmerseCommunicate/images/background-desktop-2x-min.png';

export const Section = styled(_Section)(
  ({ theme }) => css`
    display: none;

    @media (min-width: 1152px) {
      display: flex;
      padding-top: ${theme.sz.s10};
      padding-bottom: ${theme.sz.s6};
      background-color: ${theme.co.neutral0};
      background-position-x: center;
      background-position-y: top;
      background-repeat: no-repeat;
      background-image: url(${BackgroundDesktop});
      background-size: 1440px 1800px;
    }
  `,
);

export const SectionContent = styled(_Section.Content)(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${theme.sz.s6};
  `,
);
